import React from 'react';
import { useRsi } from '../../hooks/useRsi';
import { Box, Button, Typography, useBpDesignTheme, Dialog } from '@beeline.com/bp-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fields: string[];
}

export const UnmatchedFieldsAlert = ({ isOpen, onClose, onConfirm, fields }: Props) => {
  const { allowInvalidSubmit, translations } = useRsi();
  const theme = useBpDesignTheme();

  return (
    <Dialog
      title={translations.alerts.unmatchedRequiredFields.headerTitle}
      subTitle={translations.alerts.unmatchedRequiredFields.bodyText}
      open={isOpen}
      onClose={onClose}
      show={{
        cancelButton: true
      }}
      actions={
        allowInvalidSubmit
          ? [
              <Button
                onClick={onConfirm}
                style={{ marginLeft: theme.spacingSize.l }}
                color="primary"
                variant="contained"
                key="confirm"
              >
                {translations.alerts.unmatchedRequiredFields.continueButtonTitle}
              </Button>
            ]
          : undefined
      }
      id="rsi"
    >
      <Box pt={3}>
        <Typography display="inline">{translations.alerts.unmatchedRequiredFields.listTitle}</Typography>
        <Typography display="inline" fontWeight="bold">
          {' '}
          {fields.join(', ')}
        </Typography>
      </Box>
    </Dialog>
  );
};
